<template>
    <div>
        <div data-html2canvas-ignore="true" class="customdim" v-show="loader">
            <Loader />
        </div>
        <div v-if="visibleSections.manageTeamSection" class="datepickerwrap card">
            <div class="align-items-center p-0 mb-3">
                <h4 class="mb-4">My Team</h4>
                <section class="border rounded">
                    <b-row v-on:click="toggle('teamList')" class="p-3 cursor-pointer">
                        <b-col class="col-6 d-flex align-items-center">
                            <h4 class="m-0" style="font-weight: bold;">Manage Your Team</h4>
                        </b-col>
                        <b-col class="col-6 d-flex justify-content-end">
                            <i v-if="isOpen('teamList')" style="font-size: 2rem; color:#065559"
                                class="fa fa-angle-up"></i>
                            <i v-else style="font-size: 2rem; color:#065559" class="fa fa-angle-down"></i>
                        </b-col>
                    </b-row>
                    <div style="height:0.5px; background-color:#c8ced3; width:100%; display:none;"
                        :class="{ 'd-block': isOpen('teamList') }">
                    </div>
                    <div v-show="isOpen('teamList')" class="p-3 mt-2">
                        <b-row>
                            <b-col class="d-flex align-items-center">
                                <p style="font-size: 1rem; color:#4e4e4e;">Manage your team, add or edit members
                                    permission. </p>
                            </b-col>
                            <b-col class="btnSection d-flex justify-content-end h-50">
                                <!-- <img v-on:click="" v-if="selectedMember.length" class="mr-4 redTrash cursor-pointer"
                                    src="../../../public/Icons_SVG/redTrash.svg" />
                                <img v-else class="mr-4 blackTrash" src="../../../public/Icons_SVG/blackTrash.svg" /> -->
                                <button type="button" v-on:click="addNewMember()" class="btn btn-green-outline">+
                                    Add
                                    New Members</button>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <div class="mt-4">
                                    <div class="manageTeamSectionTableContainer">
                                        <table class="manageTeamSectionTable table">
                                            <thead class="bg-transparent">
                                                <tr style="font-size: 0.9rem; color:#5E5E5E;">
                                                    <th scope="col"></th>
                                                    <th scope="col">Name</th>
                                                    <th scope="col">Role</th>
                                                    <th scope="col">Date Added</th>
                                                    <th scope="col">Permissions</th>
                                                    <th scope="col">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                <tr v-for="(teamMember) in teamMembers" :key="teamMember.user_id">
                                                    <td><input v-if="teamMember.role_name.toLowerCase() !== 'admin'"
                                                            type="checkbox" v-model="selectedMember"
                                                            :value="teamMember.user_id" class="checkBox"
                                                            :key="teamMember.user_id">
                                                    </td>
                                                    <td>
                                                        <div class="d-flex align-items-center" style="gap:0.5rem;">
                                                            <img v-if="teamMember.profile_img == ''"
                                                                style="height:3rem !important; border: 5px solid #E6EEEE; border-radius:50%;"
                                                                src="../../../public/Icons_SVG/User.svg">
                                                            <img v-else
                                                                style="height:3rem !important; border: 5px solid #E6EEEE; border-radius:50%;"
                                                                :src=teamMember.profile_img>
                                                            <div>
                                                                <p class="m-0" style="color:#5e5e5e; font-size:1rem">
                                                                    {{ teamMember.first_name + " " +
                                                                        teamMember.last_name
                                                                    }}
                                                                    <span
                                                                        :class="{ bgAdmin: teamMember.role_name.toLowerCase() == 'admin', bgUser: teamMember.role_name.toLowerCase() == 'user' }"
                                                                        class="rounded p-1 text-white"
                                                                        style="font-size: 0.7rem; text-transform:capitalize;">{{
                                                                            teamMember.role_name }}</span>
                                                                </p>
                                                                <p class="m-0" style="color:#cecece">
                                                                    {{ teamMember.email_address }}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td style="text-transform:capitalize;">{{ teamMember.role_name }}
                                                    </td>
                                                    <td>{{ teamMember.date_added }}</td>
                                                    <td>
                                                        <div
                                                            class="d-flex justify-content-between align-items-center h-100">
                                                            <ul
                                                                class="permissions d-flex flex-wrap align-items-center pl-0">
                                                                <li v-for="(permission, index) in visibleFeatures(teamMember.features.featuresList)"
                                                                    :key="index">
                                                                    {{ permission }}</li>
                                                                <li v-show="teamMember.features.show"
                                                                    v-for="(permission, index) in hiddenFeatures(teamMember.features.featuresList)"
                                                                    :key="index">
                                                                    {{ permission }}</li>
                                                                <li v-if="teamMember.features.featuresList.length > 3"
                                                                    v-on:click="teamMember.features.show = !teamMember.features.show"
                                                                    style="background-color: #065559;"
                                                                    class="cursor-pointer">
                                                                    {{ !teamMember.features.show ?
                                                                        `+${hiddenFeatureCount(teamMember.features.featuresList.length)
                                                                        }` : "See Less" }}
                                                                </li>
                                                            </ul>
                                                            <!-- <div>
                                                                <b-dropdown size="lg" variant="link"
                                                                    toggle-class="text-decoration-none" no-caret>
                                                                    <template #button-content>
                                                                        <span class="ellipsisBtn">&#8942;</span><span
                                                                            class="sr-only"></span>
                                                                    </template>
<div class="dropDownMenu">
    <b-dropdown-item class="dropDownItem">
        <li><img src="../../../public/Icons_SVG/profileIcon.svg">View
            Profile</li>
    </b-dropdown-item>
    <b-dropdown-item class="dropDownItem">
        <li><img src="../../../public/Icons_SVG/trash.svg">Remove
        </li>
    </b-dropdown-item>
    <b-dropdown-item class="dropDownItem">
        <li><img src="../../../public/Icons_SVG/lockPermission.svg">Permissions
        </li>
    </b-dropdown-item>
</div>
</b-dropdown>
</div> -->
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="text-center d-flex align-items-center">
                                                            <img v-show="teamMember.role_name.toLowerCase() !== 'admin'"
                                                                v-on:click=" deleteSingleUser(teamMember.user_id)"
                                                                class="mr-4 cursor-pointer action-icon"
                                                                src="../../../public/Icons_SVG/deleteBtn.svg">
                                                            <img v-on:click="editUserDetails(teamMember)"
                                                                class="mr-4 cursor-pointer action-icon"
                                                                src="../../../public/Icons_SVG/editBtn.svg">
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr v-if="teamMembers.length == 0">
                                                    <td colspan="6">
                                                       <no-data  :loaderVariable="loader"/>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                            </b-col>
                        </b-row>
                    </div>
                </section>
            </div>
            <!--  -->
            <section class="border rounded mt-1">
                <b-row v-on:click="toggle('notificationList')" class="p-3 cursor-pointer">
                    <b-col class=" col-6 d-flex align-items-center">
                        <h4 class="m-0" style="font-weight: bold;">Manage Your Notifications</h4>
                    </b-col>
                    <b-col class="col-6 d-flex justify-content-end">
                        <i v-if="isOpen('notificationList')" style="font-size: 2rem; color:#065559"
                            class="fa fa-angle-up"></i>
                        <i v-else style="font-size: 2rem; color:#065559" class="fa fa-angle-down"></i>
                    </b-col>
                </b-row>
                <div style="height:0.5px; background-color:#c8ced3; width:100%; display:none;"
                    :class="{ 'd-block': isOpen('notificationList') }">
                </div>
                <div v-show="isOpen('notificationList')" class="p-3 mt-2">
                    <b-row>
                        <b-col class="col-7 d-flex align-items-center">
                            <p class="m-0" style="font-size: 1rem; color:#4e4e4e;">You can choose to receive
                                notifications via
                                WhatsApp,
                                Email or SMS
                            </p>
                        </b-col>
                        <b-col class="col-5 d-flex justify-content-end align-items-center">
                            <!-- <span class="btn btn-green-outline cursor-pointer py-2 px-3">
                                <span class="mr-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="1.2rem">
                                        <path fill="#25d366"
                                            d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7 .9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z" />
                                    </svg>
                                </span>View WhatsApp Pricing
                            </span> -->
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="col-12">
                            <div v-for="(featuresNotifications, index) in universalSenseNotificationsData" :key="index"
                                class="mx-3 mt-3"
                                v-if="featuresNotifications.trigger_data && featuresNotifications.trigger_data.length">
                                <b-row class="border rounded-top cursor-pointer py-1"
                                    :class="{ 'rounded-top rounded-bottom': !isOpen(featuresNotifications.feature_id,'manage') }"
                                    v-on:click="toggle(featuresNotifications.feature_id,'manage')">
                                    <b-col class="col-8 d-flex align-items-center" style="gap:0.5rem;">
                                        <p class="m-0" style="color:#008075;">{{ featuresNotifications.feature_name }}
                                        </p>
                                        <img src="../../../public/Icons_SVG/infoIcon.svg" style="height:1rem !important;">
                                    </b-col>
                                    <b-col class="col-2 d-flex align-items-center">
                                        <span v-show="isOpen(featuresNotifications.feature_id,'manage')">Email</span>
                                    </b-col>
                                    <b-col class="col-2 d-flex justify-content-end align-items-center"
                                        :class="{ 'justify-content-between': isOpen(featuresNotifications.feature_id,'manage') }">
                                        <span v-show="isOpen(featuresNotifications.feature_id,'manage')">WhatsApp</span>
                                        <span style="color:#065559; font-size:2rem;">
                                            <i v-if="isOpen(featuresNotifications.feature_id,'manage')"
                                                class="fa fa-angle-up ml-3"></i>
                                            <i v-else class="fa fa-angle-down ml-3"></i>
                                        </span>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col v-show="isOpen(featuresNotifications.feature_id,'manage')"
                                        class="featuresNotifications">
                                        <b-row v-for="(triggerData, index) in featuresNotifications.trigger_data"
                                            class="border border-top-0 py-3" :key="'notification'+triggerData.trigger_id"
                                            :class="{ 'rounded-bottom': featuresNotifications.trigger_data.length - 1 == index }">
                                            <b-col class="col-8 d-flex align-items-center" style="gap:0.5rem;">
                                                <p class="m-0">{{ triggerData.trigger_name }}</p>
                                            </b-col>
                                            <b-col class="col-2 d-flex align-items-center">
                                                <input class="ml-2" type="checkbox" name="" id="emailTrigger"
                                                    v-model="triggerData.email_alert">
                                            </b-col>
                                            <b-col class="col-2 d-flex align-items-center">
                                                <input class="ml-4" type="checkbox" name="" id="whatsappTrigger"
                                                    v-model="triggerData.whatsapp_alert">
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-row>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2 mt-3">
                        <b-col class="col-12">
                            <button type="button"
                                v-on:click="updateUniversalNoifications(universalSenseNotificationsData)"
                                class=" btn btn-success" style="background-color: #008075;">
                                Save
                                Changes
                            </button>
                        </b-col>
                    </b-row>
                </div>
            </section>
        </div>

        <div v-if="visibleSections.addNewMemberSection" class="datepickerwrap card w-full">
            <section class="teamMembers card mb-0">
                <h4 class="mb-2">Invite Team Members</h4>
                <p class="mb-4">Add new team members via notification.</p>
                <b-row class="d-flex justify-content-between align-items-center">
                    <b-col class="col-4">
                        <b-row class="mb-4">
                            <b-col>
                                <label for="user_email">Email ID</label>
                                <b-input-group class="passwordInput">
                                    <b-form-input type="email" class="emailField" id="user_email"
                                        placeholder="Enter Email" v-model="user_email"
                                        v-on:input="wrongEmailMessage = false"></b-form-input>
                                </b-input-group>
                                <span class="mt-1 inline-block" v-if="wrongEmailMessage"
                                    style="color:red; display: inline-block;">
                                    {{ user_email ? 'Please enter valid email !' : 'Please enter a email !' }}</span>
                            </b-col>
                        </b-row>
                        <b-row class="mb-4">
                            <b-col>
                                <label for="roles">Member Role</label>
                                <b-form-select name="roles" id="roles" v-model="role_id" class="select"
                                    v-on:change="validateRole()">
                                    <option value="--Select Role--" selected disabled>--Select Role--</option>
                                    <option :value="role.role_id" v-for="(role, index) in rolesInfo"
                                        :key="role.role_id">{{
                                            role.role_name }}
                                    </option>
                                </b-form-select>
                                <span class="mt-1" v-if="showRoleMessage"
                                    style="color:red; display: inline-block;">Please
                                    Select Role</span>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col class="col-8 text-right">
                        <div d-flex align-items-center>
                            <input class="checkBox" v-on:click="setAllPermission()" type="checkbox" id="AllPermissions"
                                :checked="!AllPermissions">

                            <label class="m-0 ml-2" for="AllPermissions" style="font-size: 0.9rem; color:#5e5e5e">Grant
                                All
                                Permissions</label>
                        </div>
                        <p class="text-right" style="font-size: 0.8rem;  color:#9e9e9e">Enabling this will provide
                            the
                            user with all
                            permissions and feature enabled to
                            all
                            features.</p>
                    </b-col>
                </b-row>
                <!-- Memmebr's Features access and Notifications Permissions during invitation Section -->
                <!-- <b-row v-if="!AllPermissions"> -->
                <b-row>
                    <b-col class="col-8 mt-4 card border">
                        <b-row class="border-bottom pl-3 pb-3">
                            <span v-on:click="toggleTabs('features')" class="tabItem cursor-pointer"
                                :class="{ active: featuresTab }">Features</span>
                            <span v-on:click="toggleTabs('notifications')" class="tabItem ml-4 cursor-pointer"
                                :class="{ active: notificationsTab }">Notifications</span>
                        </b-row>
                        <div v-if="featuresTab" class="card mb-0 mt-3"
                            style="border: 1px solid #dedede !important; padding:0  1rem !important;">
                            <b-row class="d-flex align-items-center border-bottom py-3">
                                <b-col>
                                    <p class="m-0">Feature Name</p>
                                </b-col>
                                <b-col class="d-flex justify-content-end align-items-center" style="gap:0.5rem;">
                                    <a v-on:click="enableAllFeature('inviteFeatures')"
                                        class="border-bottom border-success outline-0 bg-transparent text-success"
                                        style="cursor: pointer;">Enable
                                        all</a>
                                    <span>|</span>
                                    <a v-on:click="desableAllFeature('inviteFeatures')" class=" border-bottom outline-0 bg-transparent
                                        text-danger border-danger" style="cursor: pointer;">Disable
                                        all</a>
                                </b-col>
                            </b-row>
                            <b-row class="py-3" v-for="(feature, index) in features" :key="feature.feature_id"
                                :class="{ 'border-bottom': features.length - 1 !== index }">
                                <b-col class="d-flex align-items-center" style="gap:0.5rem;">
                                    <p class="m-0">{{ feature.feature_name }}</p><img
                                        src="../../../public/Icons_SVG/infoIcon.svg" style="height:1rem !important;">
                                </b-col>
                                <b-col class="d-flex justify-content-end">
                                    <b-form-checkbox v-model="feature.feature_enabled" name="check-button" switch
                                        class="text-danger"></b-form-checkbox>
                                </b-col>
                            </b-row>
                        </div>
                        <div v-if="notificationsTab" class="card mb-0 "
                            style="">
                            <!-- <b-row class="border-bottom py-3">
                                <b-col class="col-8">
                                    <p class="m-0">Feature Name</p>
                                </b-col>
                                <b-col class="col-2" style="gap:0.5rem;">
                                    <span>Email</span>
                                </b-col>
                                <b-col class="col-2" style="gap:0.5rem;">
                                    <span>WhatsApp</span>
                                </b-col>
                            </b-row> -->
                            <!-- <b-row class="py-3" v-for="(feature, index) in features" :key="feature.feature_id"
                                :class="{ 'border-bottom': features.length - 1 !== index }">
                                <b-col class="col-8 d-flex align-items-center" style="gap:0.5rem;">
                                    <p class="m-0">{{ feature.feature_name }}</p><img
                                        src="../../../public/Icons_SVG/infoIcon.svg" style="height:1rem !important;">
                                </b-col>

                                <b-col class="col-2">
                                    <input type="checkbox" name="email_access" id="" v-model="feature.email_access">
                                </b-col>
                                <b-col class="col-2  text-center">
                                    <input type="checkbox" name="whatsApp_access" id=""
                                        v-model="feature.whatsapp_access">
                                </b-col>
                            </b-row> -->
                            <div v-for="(featuresNotifications, index) in universalInviteNewMemberNotificationsData" :key="index"
                                class="mb-2"
                                v-if="featuresNotifications.trigger_data && featuresNotifications.trigger_data.length">
                                <b-row class="border rounded-top cursor-pointer py-1"
                                    :class="{ 'rounded-top rounded-bottom': !isOpen(featuresNotifications.feature_id,'invite') }"
                                    v-on:click="toggle(featuresNotifications.feature_id,'invite')">
                                    <b-col class="col-8 d-flex align-items-center" style="gap:0.5rem;">
                                        <p class="m-0" style="color:#008075;">{{ featuresNotifications.feature_name }}
                                        </p>
                                        <img src="../../../public/Icons_SVG/infoIcon.svg" style="height:1rem !important;">
                                    </b-col>
                                    <b-col class="col-2 d-flex align-items-center">
                                        <span v-show="isOpen(featuresNotifications.feature_id,'invite')">Email</span>
                                    </b-col>
                                    <b-col class="col-2 d-flex justify-content-end align-items-center"
                                        :class="{ 'justify-content-between': isOpen(featuresNotifications.feature_id,'invite') }">
                                        <span v-show="isOpen(featuresNotifications.feature_id,'invite')">WhatsApp</span>
                                        <span style="color:#065559; font-size:2rem;">
                                            <i v-if="isOpen(featuresNotifications.feature_id,'invite')"
                                                class="fa fa-angle-up ml-3"></i>
                                            <i v-else class="fa fa-angle-down ml-3"></i>
                                        </span>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col v-show="isOpen(featuresNotifications.feature_id,'invite')"
                                        class="featuresNotifications">
                                        <b-row v-for="(triggerData, index) in featuresNotifications.trigger_data"
                                            class="border border-top-0 py-3" :key="triggerData.trigger_id"
                                            :class="{ 'rounded-bottom': featuresNotifications.trigger_data.length - 1 == index }">
                                            <b-col class="col-8 d-flex align-items-center" style="gap:0.5rem;">
                                                <p class="m-0">{{ triggerData.trigger_name }}</p>
                                            </b-col>
                                            <b-col class="col-2 d-flex align-items-center">
                                                <input class="ml-2" type="checkbox" name="" id="emailTrigger"
                                                    v-model="triggerData.email_alert">
                                            </b-col>
                                            <b-col class="col-2 d-flex align-items-center">
                                                <input class="ml-4" type="checkbox" name="" id="whatsappTrigger"
                                                    v-model="triggerData.whatsapp_alert">
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-row>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <!-- ! Memmebr's Features access and Notifications Permissions during invitation Section -->

                <b-row class="mb-4 ">
                    <b-col class="col-12 text-right">
                        <button type="button" v-on:click="toggleSection(visibleSections)"
                            class="btn mr-4 btn-green-outline">Cancel</button>
                        <button type="button" v-on:click="inviteUser(visibleSections)" class="btn btn-success"
                            style="background-color: #008075;">
                            Invite
                            User
                        </button>
                    </b-col>
                </b-row>
            </section>
        </div>
        <div v-if="editTeamSection" class="datepickerwrap card w-full">
            <section class="editTeams card mb-0">
                <h4 class="mb-2">Edit Team</h4>
                <p class="mb-4">Change team member’s permissions.</p>
                <b-row class="d-flex align-items-center">
                    <div class="mr-3">

                        <img v-if="editMemberDetails.profile_img == ''"
                            style="height:4rem !important; border: 5px solid #E6EEEE; border-radius:50%;"
                            src="../../../public/Icons_SVG/User.svg">
                        <img v-else style="height:4rem !important; border: 5px solid #E6EEEE; border-radius:50%;"
                            :src="editMemberDetails.profile_img">
                    </div>
                    <div>
                        <p class="m-0" style="color:#5e5e5e; font-size:1rem">
                            {{ editMemberDetails.first_name + " " + editMemberDetails.last_name }}
                            <span v-if="editMemberDetails.role_name == 'user'" class="bgUser rounded p-1 text-white"
                                style="font-size: 0.7rem;">{{ editMemberDetails.role_name }}</span>
                        </p>
                        <p class="m-0" style="color:#5e5e5e">
                            {{ editMemberDetails.email_address }}
                        </p>
                        <p class="m-0" style="color:#cecece">
                            <span>Date Added:</span> {{ editMemberDetails.date_added }}
                        </p>
                    </div>
                </b-row>
                <!--Edit Memmebr's Features access and Notifications Permissions Section -->
                <b-row>
                    <b-col class="col-8 mt-4 card border">
                        <b-row class="border-bottom pl-3 pb-3">
                            <span v-on:click="toggleTabs('features')" class="tabItem cursor-pointer"
                                :class="{ active: featuresTab }">Features</span>
                            <span v-on:click="toggleTabs('notifications')" class="tabItem ml-4 cursor-pointer"
                                :class="{ active: notificationsTab }">Notifications</span>
                        </b-row>
                        <div v-if="featuresTab" class="card mb-0 mt-3"
                            style="border: 1px solid #dedede !important; padding:0  1rem !important;">
                            <b-row class="d-flex align-items-center border-bottom py-3">
                                <b-col>
                                    <p class="m-0">Feature Name</p>
                                </b-col>
                                <b-col class="d-flex justify-content-end align-items-center" style="gap:0.5rem;">
                                    <a v-on:click="enableAllFeature('updateFeatures')"
                                        class="border-bottom border-success outline-0 bg-transparent text-success"
                                        style="cursor: pointer;">Enable
                                        all</a>

                                    <span>|</span>
                                    <a v-on:click="desableAllFeature('updateFeatures')" class=" border-bottom outline-0 bg-transparent
                                        text-danger border-danger" style="cursor: pointer;">Disable
                                        all</a>
                                </b-col>
                            </b-row>
                            <b-row class="py-3" v-for="(features, index) in updatedMemberDetails.feature_data"
                                :key="features.feature_id"
                                :class="{ 'border-bottom': updatedMemberDetails.feature_data.length - 1 !== index }">
                                <b-col class="d-flex align-items-center" style="gap:0.5rem;">
                                    <p class="m-0">{{ features.feature_name }}</p><img
                                        src="../../../public/Icons_SVG/infoIcon.svg" style="height:1rem !important;">
                                </b-col>
                                <b-col class="d-flex justify-content-end">
                                    <b-form-checkbox v-model="features.feature_enabled" name="check-button" switch
                                        class="text-danger"></b-form-checkbox>
                                </b-col>
                            </b-row>
                        </div>
                        <div v-if="notificationsTab" class="card mb-0">
                            <!-- <b-row class="border-bottom py-3">
                                <b-col class="col-8">
                                    <p class="m-0">Feature Name</p>
                                </b-col>
                                <b-col class="col-2" style="gap:0.5rem;">
                                    <span>Email</span>
                                </b-col>
                                <b-col class="col-2" style="gap:0.5rem;">
                                    <span>WhatsApp</span>
                                </b-col>
                            </b-row> -->
                            <!-- <b-row class="py-3"
                                v-for="(featuresNotifications, index) in updatedMemberDetails.sense_notification_data"
                                :key="featuresNotifications.feature_id"
                                :class="{ 'border-bottom': updatedMemberDetails.sense_notification_data.length - 1 !== index }">
                                <b-col class="col-8 d-flex align-items-center" style="gap:0.5rem;">
                                    <p class="m-0">{{ featuresNotifications.feature_name }}</p>
                                    <img src="../../../public/Icons_SVG/infoIcon.svg" style="height:1rem !important;">
                                </b-col>

                                <b-col class="col-2">
                                    <input type="checkbox" name="email_access" id=""
                                        v-model="featuresNotifications.email_access">
                                </b-col>
                                <b-col class="col-2  text-center">
                                    <input type="checkbox" name="whatsApp_access" id=""
                                        v-model="featuresNotifications.whatsapp_access">
                                </b-col>
                            </b-row> -->
                              <div v-for="(featuresNotifications, index) in updatedMemberDetails.sense_notification_data" :key="index"
                                class="mb-2"
                                v-if="featuresNotifications.trigger_data && featuresNotifications.trigger_data.length">
                                <b-row class="border rounded-top cursor-pointer py-1"
                                    :class="{ 'rounded-top rounded-bottom': !isOpen(featuresNotifications.feature_id,'edit') }"
                                    v-on:click="toggle(featuresNotifications.feature_id,'edit')">
                                    <b-col class="col-8 d-flex align-items-center" style="gap:0.5rem;">
                                        <p class="m-0" style="color:#008075;">{{ featuresNotifications.feature_name }}
                                        </p>
                                        <img src="../../../public/Icons_SVG/infoIcon.svg" style="height:1rem !important;">
                                    </b-col>
                                    <b-col class="col-2 d-flex align-items-center">
                                        <span v-show="isOpen(featuresNotifications.feature_id,'edit')">Email</span>
                                    </b-col>
                                    <b-col class="col-2 d-flex justify-content-end align-items-center"
                                        :class="{ 'justify-content-between': isOpen(featuresNotifications.feature_id,'edit') }">
                                        <span v-show="isOpen(featuresNotifications.feature_id,'edit')">WhatsApp</span>
                                        <span style="color:#065559; font-size:2rem;">
                                            <i v-if="isOpen(featuresNotifications.feature_id,'edit')"
                                                class="fa fa-angle-up ml-3"></i>
                                            <i v-else class="fa fa-angle-down ml-3"></i>
                                        </span>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col v-show="isOpen(featuresNotifications.feature_id,'edit')"
                                        class="featuresNotifications">
                                        <b-row v-for="(triggerData, index) in featuresNotifications.trigger_data"
                                            class="border border-top-0 py-3" :key="triggerData.trigger_id"
                                            :class="{ 'rounded-bottom': featuresNotifications.trigger_data.length - 1 == index }">
                                            <b-col class="col-8 d-flex align-items-center" style="gap:0.5rem;">
                                                <p class="m-0">{{ triggerData.trigger_name }}</p>
                                            </b-col>
                                            <b-col class="col-2 d-flex align-items-center">
                                                <input class="ml-2" type="checkbox" name="" id="emailTrigger"
                                                    v-model="triggerData.email_alert">
                                            </b-col>
                                            <b-col class="col-2 d-flex align-items-center">
                                                <input class="ml-4" type="checkbox" name="" id="whatsappTrigger"
                                                    v-model="triggerData.whatsapp_alert">
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-row>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <!-- !Edit Memmebr's Features access and Notifications Permissions Section -->

                <b-row class="mb-4 ">
                    <b-col class="col-12">
                        <button type="button" v-on:click="updateEditUserInfo(updatedMemberDetails)"
                            class=" btn btn-success" style="background-color: #008075;">
                            <b-spinner small v-if="isUploadingLoader" style="margin-right:0.5rem;"></b-spinner>Save
                            Changes
                        </button>
                        <button type="button" v-on:click="toggleSection(visibleSections)"
                            class="btn ml-4 btn-warning text-white">Back</button>
                    </b-col>
                </b-row>
            </section>
        </div>
        <b-modal title="Confirm Delete Team Member" v-model="deleteRequestModal" class="container-modal-ASIN">
            <div class="modal-delete-content-user d-flex align-items-start mb-2">
                <div class="delete-alert-user text-center rounded-circle px-2 mr-3">&#9888;</div>
                <!-- <div>Do you want to delete the request ASIN ?</div> -->
                <div>You're going to delete this team member<br>Are you sure ?</div>
            </div>
            <div class="d-flex justify-content-end">
                <b-button @click="closeConfirmModal" class="btn primarycolorUser">No, Keep It.</b-button>
                <button @click="confirmDeleteUser"
                    class="btn primarycolorUser px-3 py-1 ml-2 d-flex align-items-center delete-requestBtn"
                    style="background-color: var(--red)">Ok
                </button>
            </div>
        </b-modal>

    </div>

</template>

<script>
import Loader from '../Components/Loader.vue';
import NoData from '../Components/noData.vue';
import noData from '../Components/noData.vue';
export default {
    name: "UserManagement",
    components: {
        Loader,
        NoData
    },
    computed: {

    },
    mounted() {
        this.toggle('teamList');
        this.fetchRolesInfo();
        this.fetchFeatures();
        this.fetchTeamMemberDetails()
        this.fetchUniversalNotificationsData();
        this.$store.dispatch("DemoStore/setTimeStamp", ""); //using for clear the last updated time stamp
        this.$store.dispatch("DemoStore/setUpdatedStatus", '')
    },
    data: function () {
        return {
            openAccordian: null,
            showHiddenFeatures: false,
            openSection: null,
            AllPermissions: false,
            user_email: "",
            wrongEmailMessage: false,
            isRoleSelected: false,
            showRoleMessage: false,
            role_id: "",
            rolesInfo: [],
            features: [],
            universalSenseNotificationsData: [],
            universalInviteNewMemberNotificationsData: [],
            universalSenseNotificationsCopyData: [],
            editMemberDetails: [],
            updatedMemberDetails: [],
            storeDeleteUserId: [],
            selectedMemberUserId: null,
            Notification: false,
            selectedMember: [],
            teamMembers: [],
            setAccess: true,
            deleteRequestModal: false,
            activeTab: true,
            featuresTab: null,
            notificationsTab: false,
            editTeamSection: false,
            myTeamSection: true,
            inviteMemberSection: false,
            visibleSections: {
                manageTeamSection: true,
                addNewMemberSection: false,
            },
            loader: false,
            teamMemberLoader: false,

        }
    },
    methods: {
        toggle(id,section) {
            if (id === 'teamList' || id === 'notificationList') {
                this.openSection = this.openSection === id ? null : id;
                // this.openSection = null;
            }
            else {
                this.openAccordian = this.openAccordian === section+id ? null : section+id;
                // this.openSection = null;
            }
        },
        isOpen(id,section) {
            if (id === 'teamList' || id === 'notificationList') {
                return this.openSection === id;
            }
            else {
                return this.openAccordian === section+id;
            }
        },
        closeConfirmModal() {
            this.deleteRequestModal = false;
            this.storeDeleteUserId = [];
        },
        visibleFeatures(features) {
            return features.slice(0, 3);
        },
        // Get the count of hidden elements
        hiddenFeatureCount(featuresCount) {
            return featuresCount > 3 ? featuresCount - 3 : 0;
        },
        // Get the hidden elements
        hiddenFeatures(features) {
            return features.slice(3);
        },

        deleteSingleUser(user_id) {
            this.deleteRequestModal = true;
            this.storeDeleteUserId.push(user_id);
        },
        confirmDeleteUser() {
            let url = `/api/sense/editUserAccess?user_id=${this.storeDeleteUserId[0]}`;
            this.loader = true;
            this.$http.delete(url)
                .then((response) => {
                    this.loader = false;
                    this.$bvToast.toast(`User Deleted! ✅`, {
                        title: "Weavr Sense - Team",
                        variant: "success",
                        toaster: "b-toaster-top-right",
                        autoHideDelay: 3000,
                    });
                    this.closeConfirmModal()
                    this.fetchTeamMemberDetails()
                })
                .catch((error) => {
                    console.error('Error occurred while attempting to delete User', error.body.summary);
                    this.loader = false;
                    this.$bvToast.toast(`Unable to delete member/User`, {
                        title: "Weavr Sense - Team",
                        variant: "danger",
                        toaster: "b-toaster-top-right",
                        autoHideDelay: 3000,
                    });
                });
        },
        deleteMultipleUser() {
            let confirmValue = confirm("Are you sure you want to delete selected members?");
            if (confirmValue) {
            }
        },
        editUserDetails(teamMember) {
            this.myTeamSection = false;
            this.editTeamSection = true;
            this.featuresTab = this.activeTab;
            this.visibleSections.manageTeamSection = false;
            this.visibleSections.addNewMemberSection = false;
            this.selectedMemberUserId = teamMember.user_id;
            this.editMemberDetails = teamMember;
            this.featuresTab = this.activeTab;
            this.notificationsTab = !this.activeTab;
            this.loader = true;
            let url = `/api/sense/editUserAccess?user_id=${this.selectedMemberUserId}`;
            this.$http.get(url)
                .then((response) => {
                    return response.json();
                })
                .then((jsonData) => {
                    this.updatedMemberDetails = { "user_id": this.selectedMemberUserId, ...jsonData.data };
                    this.loader = false;
                })
                .catch((err) => {
                    console.error('Error occurred while attempting to Edit User Details', error);
                    this.loader = false;
                    this.$bvToast.toast(`Unable to Edit Member Details`, {
                        title: "Weavr Sense - Team",
                        variant: "danger",
                        toaster: "b-toaster-top-right",
                        autoHideDelay: 3000,
                    });
                });
        },
        updateEditUserInfo(updatedMemberInfo) {
            this.loader = true;
            let data = {
                user_id: updatedMemberInfo.user_id,
                features_data: updatedMemberInfo.feature_data.map(obj => ({ feature_id: obj.feature_id, feature_enabled: obj.feature_enabled })),
                sense_notification_data: updatedMemberInfo.sense_notification_data
            }
            let url = "/api/sense/editUserAccess";
            this.loader = true;
            this.$http.post(url, data)
                .then((response) => {
                    this.loader = false;
                    this.$bvToast.toast(`Details Updated ✅`, {
                        title: "Weavr Sense - Team",
                        variant: "success",
                        toaster: "b-toaster-top-right",
                        autoHideDelay: 3000,
                    });
                    this.fetchTeamMemberDetails();
                    this.loader = false;
                    this.editTeamSection = !this.editTeamSection;
                    this.visibleSections.manageTeamSection = !this.visibleSections.manageTeamSection;
                })
                .catch((error) => {
                    console.error('Error occurred while attempting to Change Features and Notifications Details', error);
                    this.loader = false;
                    this.$bvToast.toast(`Unable to change Features and Notifications`, {
                        title: "Weavr Sense - Team",
                        variant: "danger",
                        toaster: "b-toaster-top-right",
                        autoHideDelay: 3000,
                    });
                });
        },
        updateUniversalNoifications(updatedSenseNotificationsData) {
            let data = { sense_notification_data: updatedSenseNotificationsData }
            let url = "/api/sense/notification";
            this.loader = true;
            this.$http.post(url, data)
                .then((response) => {
                    this.loader = false;
                    this.$bvToast.toast(`Notifications Updated! ✅`, {
                        title: "Weavr Sense - Team",
                        variant: "success",
                        toaster: "b-toaster-top-right",
                        autoHideDelay: 3000,
                    });
                    this.fetchUniversalNotificationsData();
                })
                .catch((error) => {
                    console.error('Error occurred while changing Universal Notifications Update:', error);
                    this.loader = false;
                    this.$bvToast.toast(`Unable to Change Notifications`, {
                        title: "Weavr Sense - Team",
                        variant: "danger",
                        toaster: "b-toaster-top-right",
                        autoHideDelay: 3000,
                    });
                });
        },
        addNewMember() {
            this.inviteMemberSection = true;
            this.myTeamSection = false;
            this.AllPermissions = false;
            this.toggleSection(this.visibleSections);
            this.grantAllPermissions();
            this.toggleTabs("features")
        },
        toggleSection(toggleSections) {
            if (this.editTeamSection) {
                this.editTeamSection = !this.editTeamSection;
                toggleSections.manageTeamSection = !toggleSections.manageTeamSection;
                toggleSections.addNewMemberSection = false;
            }
            else {
                toggleSections.manageTeamSection = !toggleSections.manageTeamSection
                toggleSections.addNewMemberSection = !toggleSections.addNewMemberSection
                this.user_email = "";
                this.role_id = "--Select Role--";
                this.showRoleMessage = false;
                this.wrongEmailMessage = false;
                this.notificationsTab = true;
                this.featuresTab = false;
            }
        },
        toggleTabs(tab) {
            if (tab === 'features') {
                this.featuresTab = this.activeTab;
                this.notificationsTab = !this.activeTab;
            }
            if (tab == 'notifications') {
                this.notificationsTab = this.activeTab;
                this.featuresTab = !this.activeTab;
            }
        },
        setAllPermission() {
            this.grantAllPermissions()
            if (!this.permissions) {
                this.featuresTab = this.activeTab;
            }
            this.notificationsTab = !this.activeTab;
        },
        fetchRolesInfo() {
            let url = "/api/sense/rolesInfo";
            this.$http.get(url)
                .then((response) => {
                    return response.json();
                })
                .then((jsonData) => {
                    this.rolesInfo = jsonData.data
                })
                .catch((err) => {
                    console.error("Could not fetch Roles Information", err);
                });
        },
        fetchFeatures() {
            let url = "/api/sense/clientFeatures";
            this.$http.get(url)
                .then((response) => {
                    return response.json();
                })
                .then((jsonData) => {
                    this.features = jsonData.data.map((features) => {
                        return {
                            ...features, "feature_enabled": false, "email_access": false, "whatsapp_access": false
                        }
                    }
                    )
                })
                .catch((err) => {
                    console.error("Could not fetch Features data", err);
                });
        },
        fetchUniversalNotificationsData() {
            let url = "/api/sense/notification";
            this.$http.get(url)
                .then((response) => {
                    return response.json();
                })
                .then((jsonData) => {
                    this.universalSenseNotificationsData = jsonData.data;
                    this.universalInviteNewMemberNotificationsData = jsonData.data;
                    this.universalSenseNotificationsCopyData = [...this.universalSenseNotificationsData];
                })
                .catch((err) => {
                    console.error("Could not fetch Universal Notifications Data", err);
                });
        },
        grantAllPermissions() {
            this.AllPermissions = !this.AllPermissions;
            if (!this.AllPermissions) {
                this.features.forEach((element) => {
                    element.feature_enabled = true;
                    element.email_access = true;
                    element.whatsapp_access = true;
                });
                this.universalInviteNewMemberNotificationsData.forEach((feature) => {
                    feature.trigger_data.forEach((trigger) => {
                        trigger.email_alert = true;
                        trigger.whatsapp_alert = true;
                    });
                });
            } else {
                this.features.forEach((element) => {
                    element.feature_enabled = false;
                    element.email_access = false;
                    element.whatsapp_access = false;
                });
                this.universalInviteNewMemberNotificationsData.forEach((feature) => {
                    feature.trigger_data.forEach((trigger) => {
                        trigger.email_alert = false;
                        trigger.whatsapp_alert = false;
                    });
                });
            }
            
        },
        enableAllFeature(ifFeatures) {
            this.AllPermissions = false;
            if (ifFeatures === "updateFeatures") {
                this.updatedMemberDetails.feature_data.forEach((element) => {
                    element.feature_enabled = true;
                });
            }
            if (ifFeatures === "inviteFeatures") {
                this.features.forEach((element) => {
                    element.feature_enabled = true;
                });
            }
        },
        desableAllFeature(ifFeatures) {
            this.AllPermissions = true;
            if (ifFeatures === "updateFeatures") {
                this.updatedMemberDetails.feature_data.forEach((element) => {
                    element.feature_enabled = false;
                });
            }

            if (ifFeatures === "inviteFeatures") {
                this.features.forEach((element) => {
                    element.feature_enabled = false;
                });
            }

        },
        validateRole() {
            this.isRoleSelected = true;
            this.showRoleMessage = false;
            return true;
        },
        inviteUser(visibleSections) {
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (emailRegex.test(this.user_email) && this.isRoleSelected) {

                // Check if at least one feature is enabled
                const isAnyFeatureEnabled = this.features.some((feature) =>
                    feature.feature_enabled || feature.email_access || feature.whatsapp_access
                );

                // If no feature is enabled, show toast and return
                if (!isAnyFeatureEnabled) {
                    this.$bvToast.toast(`At least one feature should be enabled!`, {
                        title: "Weavr Sense - Team",
                        variant: "warning",
                        toaster: "b-toaster-top-right",
                        autoHideDelay: 3000,
                    });
                    return;  // Stop the function execution
                }

                const payload = {
                    user_email: this.user_email,
                    role_id: this.role_id,
                    features_data: this.features.map((feature) => {
                        return {
                            feature_id: feature.feature_id, feature_enabled: feature.feature_enabled
                        }
                    }),
                    // SenseNotification_data: this.features.map((feature) => {
                    //     return {
                    //         feature_id: feature.feature_id, email_access: feature.email_access, whatsapp_access: feature.whatsapp_access
                    //     }
                    // }
                    // )
                    SenseNotification_data: this.universalInviteNewMemberNotificationsData
                };
                let url = "/api/sense/inviteUser";
                this.loader = true;
                this.$http.post(url, payload)
                    .then((response) => {
                        this.loader = false;
                        this.$bvToast.toast(`User Invited! and Verification email sent ✅`, {
                            title: "Weavr Sense - Team",
                            variant: "success",
                            toaster: "b-toaster-top-right",
                            autoHideDelay: 3000,
                        });
                        this.user_email = "";
                        this.role_id = "--Select Role--";
                        this.toggleSection(visibleSections);
                        this.isRoleSelected = false;

                    }).catch((error) => {
                        this.loader = false;
                        this.$bvToast.toast(`${error.body.summary}`, {
                            title: "Weavr Sense - Team",
                            variant: "danger",
                            toaster: "b-toaster-top-right",
                            autoHideDelay: 3000,
                        });
                    });
            } else {
                if (!emailRegex.test(this.user_email)) {

                    this.wrongEmailMessage = true;
                }
                if (!this.isRoleSelected) {
                    this.showRoleMessage = true;
                }
            }
        },
        fetchTeamMemberDetails() {
            this.loader = true;
            let url = "/api/sense/teamMember";
            this.$http.get(url)
                .then((response) => {
                    return response.json()
                })
                .then((jsonData) => {
                    this.loader = false;
                    this.teamMembers = jsonData.data.map((member) => {
                        return {
                            ...member,
                            features: {
                                show: false,
                                featuresList: [...member.features]
                            },
                        };
                    });
                })
                .catch((error) => {
                    console.error('Error occurred whilefetching userDetails:', error);
                    this.loader = false;
                    this.$bvToast.toast(`Unable to fetch User Details`, {
                        title: "Weavr Sense - Team",
                        variant: "danger",
                        toaster: "b-toaster-top-right",
                        autoHideDelay: 3000,
                    });
                });
        },
    }
}
</script>

<style scoped>
li {
    list-style: none;
}

.cursor-pointer {
    cursor: pointer;
}

.btn-green-outline {
    border: 1px solid #008075;
    color: #008075;
    background-color: white !important;
    transition: all 0.05s ease-in-out;
}

.btn-green-outline:hover {
    background-color: #008075 !important;
    color: #fff
}

.tabItem {
    color: #000;
    font-weight: 400;
    font-size: 1rem;
}

.active {
    color: #008075 !important;
    position: relative;
}

.active::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 2px;
    bottom: -75%;
    left: 0;
    background-color: #008075;
    color: #008075 !important;
}

.bgAdmin {
    background-color: #065559;
}

.bgUser {
    background-color: #F8B018;
}

.bgInactive {
    background-color: #2E2E2E;
}

.show {
    display: block !important;
}

.hide {
    display: none !important;
}

.btnSection img {
    cursor: pointer;
}

.manageTeamSectionTable {
    margin: 0 !important;
    border: 1px solid #ebebeb;
}

.manageTeamSectionTable tr {
    border-bottom: 1px solid #c8ced3 !important;
    transition: all 0.05s;
}

.card {
    border: none;
}

.permissions {
    list-style: none;
    gap: 1rem;
    margin: 0;
}

.permissions li {
    background-color: #5E5E5E;
    color: #fff;
    padding: 0.3rem 0.5rem;
    border-radius: 0.2rem;
}

.permissionItem {
    color: #065559;
}

.ellipsisBtn {
    color: #065559;
    font-size: 1.2rem;
    padding: 0 0.7rem;
    border-radius: 0.5rem;
    transition: all 0.1s ease-in-out;
    cursor: pointer;
    z-index: 120;
    position: relative;
}

.ellipsisBtn:hover {
    background-color: #EBEBEB;
}

thead,
tbody {
    font-family: inherit;
    color: inherit;
}

tbody tr:hover {
    background-color: #eaeaea3c;
}


th,
td {
    text-align: left;
    vertical-align: middle;
}

.dropDownMenu {
    position: absolute;
    top: 0;
    right: 70%;
    background-color: #f9f9f9;
    box-shadow: 0 2px 6.5px #00000025;
    z-index: 9999999999;
    border-radius: 5px;
    padding: 0.5em;
}

.dropDownMenu li {
    display: inline-flex;
    gap: 1rem;
    align-items: center;
    border-radius: 0.5em;
    width: 100%;
    text-align: left;
    cursor: pointer;
}

input[type="checkbox"],
.checkBox {
    accent-color: #065559;
    width: 0.9rem;
    height: 0.9rem;
    border: 1px solid #065559;
    box-shadow: none;
}

.action-icon {
    transition: all 0.2s ease-in-out;
    opacity: 0.7;
}

.action-icon:hover {
    transform: scale(1.1);
    opacity: 1;
}

.featuresNotifications p {
    color: #5E5E5E;
}

.collapsed>.when-open,
.not-collapsed>.when-closed {
    display: none;
}
</style>
<style>
/*--------CSS OverWrite-----*/
.dropdown-menu {
    border: 0 !important;
}

button:focus {
    border-color: transparent !important;
}

.custom-control-label::before {
    background-color: #fff;
    border: #EBEBEB solid 1px;
}

.custom-control-label:hover {
    cursor: pointer;
}

.custom-switch .custom-control-label::after {
    background-color: #D9D9D9;
}

.custom-control-input:checked~.custom-control-label::before {
    border-color: #00555A;
    background-color: #fff;
}

.custom-switch .custom-control-input:checked~.custom-control-label::after {
    background-color: #00555a;
}

input[type="checkbox"] {
    cursor: pointer;
}

.delete-alert-user {
    background-color: #ffecec !important;
    color: var(--red);
    font-size: 30px;
    width: 45px;
    height: 45px;
}

.modal-delete-content-user {
    color: var(--primary_brand);
    font-size: 16px;
    margin-bottom: 5px;
    font-family: poppins;
}

button.primarycolorUser {
    background: var(--primary_brand);
    font-family: Poppins, sans-serif;
    color: #fff;
    padding: 5px 25px;
    border-radius: 6px;
    letter-spacing: .2px;
    font-weight: 700;
    font-size: 16px;
}

button.primarycolorUser:hover {
    color: #fff;
    background: var(--primary_brand-80);
}
</style>
